import { DestinationOrganizerProfile } from '@eventbrite/event-renderer';
import { OrganicEventSearchApiResponse } from '../../../../api/searchOrganicEvents';
import { useBaseEventsQuery } from './events';

const getOrganizersFromEvents = (
    data: OrganicEventSearchApiResponse,
): DestinationOrganizerProfile[] =>
    data.events.results
        .filter((event) => event.primary_organizer)
        .map((event) => event.primary_organizer as DestinationOrganizerProfile)
        .filter(
            (org, index, orgs) =>
                orgs.findIndex((organizer) => organizer.id === org.id) ===
                index,
        );

export const useOrganizersInEvents = () =>
    useBaseEventsQuery<DestinationOrganizerProfile[]>(
        getOrganizersFromEvents,
        {},
        {
            optOutDedupeEvents: true,
        },
    );
